import { TableCell, TableRow } from "monday-ui-react-core";
import { YearlyInvestmentSummary } from "../../../types/investment-summary";
import Classes from "./YaerlyInvestmentSummaryDisplay.module.scss";

type YearlyInvestmentSummaryDisplayProps = {
  yearlyInvestmentSummary: YearlyInvestmentSummary;
};
const YearlyInvestmentSummaryDisplay = ({
  yearlyInvestmentSummary,
}: YearlyInvestmentSummaryDisplayProps) => {
  return (
    <TableRow>
      {Object.values(yearlyInvestmentSummary).map((value, index) => (
        <TableCell
          className={Classes.tableCell}
          key={`year-investment-summary-${index}`}
        >
          {value}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default YearlyInvestmentSummaryDisplay;
